import { useState, useEffect } from "react";
import { message } from "antd";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../usecontext/AuthContext";
import configJson from "../../Config.json";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";

export const useReworkData = (bid) => {
  const [reworkDrawerVisible, setReworkDrawerVisible] = useState(false);
  const [reworkData, setReworkData] = useState([]);
  const [showRoundButton, setShowRoundButton] = useState(false);
  const [hasQcStatus, setHasQcStatus] = useState(false);
  const [roundName, setRoundName] = useState(false);

  const [loading, setLoading] = useState(false);
  const { accessToken } = useAuthToken();

  const checkRoundButtonVisibility = async (inputBid = bid) => {
    if (!inputBid || !inputBid.trim()) {
      setShowRoundButton(false);
      setHasQcStatus(false);
      setReworkData([]);
      setReworkDrawerVisible(false);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        CommonObj.Endpoints.GetRoundInformationforRework,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            "X-CSRF-Token": encryptTimestamp()
          },
          body: JSON.stringify({ bid: inputBid }),
        }
      );

      if (!response.ok) {
        throw new Error(`Status ${response.status}`);
      }

      const data = await response.json();

      let hasRoundText = false;
      let hasQc = false;
      let dataArray = [];
      let buttonName = "";

      if (Array.isArray(data)) {
        dataArray = data;

        hasRoundText = data.some(
          (item) => item && item.roundText && item.roundText.trim() !== ""
        );
        hasQc = data.some(
          (item) => item && String(item.qcStatus ?? "").trim().length > 0
        );
      } else if (data && typeof data === "object") {
        dataArray = [data];

        hasRoundText = data.roundText && data.roundText.trim() !== "";
        hasQc = data.qcStatus && data.qcStatus.trim() !== "";
        buttonName = data?.roundText;
      }
      setReworkData(dataArray);
      setShowRoundButton(hasRoundText);
      setHasQcStatus(hasQc);
      setRoundName(buttonName);
      return hasRoundText;
    } catch (error) {
      console.error("Failed to check rework information:", error);

      if (error.message !== "Status 404") {
        message.error("Invalid BID.Please enter a valid BID");
      }
      setShowRoundButton(false);
      setHasQcStatus(false);
      setReworkData([]);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  if (!bid || !bid.trim()) {
    setShowRoundButton(false);
    setReworkData([]);
    setReworkDrawerVisible(false);
    return;
  }

  if (bid && bid.trim().length !== 16) {
    // message.error("The BID should be 16 characters")
    return;
  }

  const timer = setTimeout(() => {
    checkRoundButtonVisibility(bid);
  }, 500);

  return () => clearTimeout(timer);
}, [bid]);
  const openReworkDrawer = () => {
    setReworkDrawerVisible(true);
  };

  const closeReworkDrawer = () => {
    setReworkDrawerVisible(false);
  };

  return {
    reworkDrawerVisible,
    reworkData,
    showRoundButton,
    roundName,
    hasQcStatus,
    loading,
    openReworkDrawer,
    closeReworkDrawer,
    refreshReworkData: checkRoundButtonVisibility,
  };
};
